<template>
  <div class="header_wrap">
    <div class="header_content">
      <div class="title" @click="goHome">
        <!-- <img src="@/assets/images/common/header_logo.jpg" alt=""> -->
        <img :src="$store.getters.sysLogo || '@/assets/images/common/header_logo.jpg'" style="height: 50px; width: 50px;" alt="">
        <p>{{ $store.getters.sysPlatformName }} </p>
      </div>
      <div class="content">
        <div class="user_info">
          <img :src="userInfo.headImgUrl ? userInfo.headImgUrl : person " @error="userInfo.headImgUrl = person">
          <div class="info">
            <p>{{ userInfo.idName }}</p>
            <p v-if="languageType!=='en'">{{ userInfo.userRole | filterRole }}</p>
            <p v-else>{{ userInfo.userRole  }}</p>
          </div>
        </div>
        <ul class="tool">
          <li @click="goHome">
            <v-icon name="home" scale="1.5"></v-icon>
            <p>首页</p>
          </li>
          <li @click="refreshPage">
            <v-icon name="redo" scale="1.2"></v-icon>
            <p>刷新</p>
          </li>
          <li class="setting">
            <v-icon name="cog" scale="1.3"></v-icon>
            <p>设置</p>
            <div class="set_wrap">
              <router-link   to="/setting/personal">个人设置</router-link>
              <!-- <router-link to="/org/setting"  v-if="userInfo.userRole === 'organ'">会员协会设置</router-link> -->
              <!-- <router-link to="/center/setting" v-if="userInfo.userRole === 'youth'">青训中心设置</router-link> -->
<!--              <router-link to="/trainCamp/setting" v-if="userInfo.userRole === 'trainCamp'">精英集训队设置</router-link>-->
<!--              <router-link to="/club/setting" v-if="userInfo.userRole === 'club'">俱乐部设置</router-link>-->
              <!--<router-link  to="/trainCampPlan/enrollList" v-if="['admin','system','youth'].includes(userInfo.userRole)">精英集训队报名</router-link>-->
            </div>
          </li>
          <li class="setting" v-if="userInfo.userRole === 'system' || userInfo.userRole === 'youth' || userInfo.userRole === 'club'">
            <div class="info_tip" v-if="userInfo.userRole === 'youth' || userInfo.userRole === 'club'" v-show="renewYouthNum > 0">
              {{renewYouthNum | maxNum}}
            </div>
            <v-icon name="file-invoice-dollar" scale="1.4"></v-icon>
            <p>开通</p>
            <div class="set_wrap">
              <router-link   to="/pay/list" v-if="userInfo.userRole === 'system' || userInfo.userRole === 'youth' || userInfo.userRole === 'club'">
                教练员帐号开通
              </router-link>
            </div>
          </li>
          <li @click="showTip = true">
            <v-icon name="power-off" scale="1.3"></v-icon>
            <p>退出</p>
          </li>
        </ul>
<!--        <el-dropdown trigger="click" class="language-version"  @command="changeLanguage">-->
<!--          <span class="el-dropdown-link" style="cursor:pointer">-->
<!--            {{languageType ? language(languageType) : '中英切换'}}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--          </span>-->
<!--          <el-dropdown-menu slot="dropdown">-->
<!--            <el-dropdown-item command="zh" >中文</el-dropdown-item>-->
<!--            <el-dropdown-item command="en">English</el-dropdown-item>-->
<!--          </el-dropdown-menu>-->
<!--        </el-dropdown>-->
      </div>
    </div>
    <yioks-tip :showTip="showTip" :tipMsg="$t('quitTips')" @callback='dropOut' />
  </div>
</template>

<script>

import 'vue-awesome/icons/home'
import 'vue-awesome/icons/redo'
import 'vue-awesome/icons/cog'
import 'vue-awesome/icons/power-off'
import 'vue-awesome/icons/file-invoice-dollar'
import auth from '@/api/auth'
import storage from '@/utils/storage'
import { filterRole } from '@/utils/yioks_filter'
import person from '@/assets/images/common/person.jpg'

const checkPath = []

export default {
  name: 'PageHeader',
  filters: {
    filterRole,
    maxNum(num) {
      return num >= 100 ? "99+" : num;
    },
  },
  data () {
    const languageType = storage.get('languageType')
    return {
      checkPath,
      languageType,
      showTip: false,
      person
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    },
    renewYouthNum(){
      return this.$store.state.renewYouthNum;
    },
  },
  methods: {
    // 检测是否为编辑页面，用以进行提示
    checkPach () {
      if (this.checkPath.includes(this.$route.path)) return true
      else return false
    },
    goHome () {
      // if (this.$route.path === '/home/index') return
      // this.$router.push('/home/index')
      this.$router.push('/')
    },
    refreshPage () {
      this.checkPach() ? this.a = 1 : window.location.reload()
    },
    dropOut (isSure) {
      if (isSure) {
        auth.logout().then(res => {
          storage.remove('token')
          storage.remove('loginToken')
          storage.remove('createPlan')
          this.$store.commit('clearHeart')
          this.$router.push({
            path: '/login',
            query: {}
          })
        })
      }
      this.showTip = false
    },
    changeLanguage (val) {
      this.$i18n.locale = val
      this.languageType = val
      storage.set('languageType', val)
    },
    language (type) {
      if (type === 'en') {
        return 'English'
      } else if (type === 'zh') {
        return '中文'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .header_wrap
    font-size 16px
    width 100%
    height 90px
    background #FFFFFF
    user-select none

    .header_content
      width 1024px
      height 100%
      margin 0 auto
      display flex
      justify-content space-between
      align-items center

      .title
        font-size 18px
        color #3E3E3E
        display flex
        justify-content center
        align-items center
        /*line-height .55rem*/
        cursor pointer

        img
          margin-right 10px
          width 55px
          height 55px

        p
          width 410px

      .content
        display flex
        height 100%

        .user_info
          display flex
          align-items center
          margin-right 5px

          img
            box-sizing border-box
            width 42px
            height 42px
            border 1px solid $green_color
            border-radius 42px
            margin-right 20px

          .info
            p
              &:first-child
                font-size 18px
                color $green_color
                margin-bottom 5px

        .tool
          display flex
          align-items center
          color $green_color

          li
            height 100%
            width 60px
            display flex
            flex-direction column
            justify-content center
            align-items center
            cursor pointer

            &:hover
              background $green_color
              color #FFFFFF

            &:hover > p
              display block

            p
              margin-top 5px
              font-size 14px
              display none

          .setting
            position relative

            &:hover > .set_wrap
              display block

            .set_wrap
              position absolute
              top 0
              margin-top 90px
              padding-top 5px
              background $green_color
              width 125px
              display none

              a
                display block
                text-align center
                height 27px
                /*line-height 35px*/

                &:last-child
                  padding-top 0

        .language-version
          margin-left 10px
          margin-right 20px
          display flex
          align-items center
          font-size 18px
  .info_tip{
    width: 20px;
    height: @width;
    position: absolute;
    top: 20px;
    right: 0;
    border-radius: 50%;
    color: $color_white;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    background-color: #ff0000;
  }

</style>
